// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__ul_7e","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__35v2_"};